import { Typography, withTheme } from 'material-ui';
import React, { Component } from 'react';
import FileContent from '../resource_content/FileContent';

class DocumentContent extends Component {

  render() {
    var info = this.props.resources[this.props.resourceID];
    var description = info.description;
    var docID = info.resourceID;
    var url = info.url;
    if(!description && !docID && url) {
      window.location.replace(url);
    }
    return (
      <React.Fragment>
        <Typography variant='display2'>{info.name}</Typography>
        <FileContent url={url} resources={this.props.resources}/>
      </React.Fragment>
    );
  }
}

export default withTheme()(DocumentContent);


// WEBPACK FOOTER //
// ./src/resource_content/DocumentContent.js